const getVisibleFilterByTab = (selectedTab) => {
  let filters = { isBrandFilterVisible: true };

  switch (selectedTab) {
    case 'host':
      filters = { ...filters, isDateRangeFilterVisible: true };
      break;

    case 'brand':
      filters = { ...filters, isDateRangeFilterVisible: true };
      break;

    case 'session':
      filters = { ...filters, isAccountFilterVisible: true, isPlatformFilterVisible: true, isDateRangeFilterVisible: true };
      break;

    case 'accountPlatform':
      filters = { ...filters, isAccountFilterVisible: true, isPlatformFilterVisible: true, isDateRangeFilterVisible: true, isAccountTypeFilterVisible: true };
      break;

    default:
      break;
  }

  return filters;
};

export default getVisibleFilterByTab;
